import React from 'react';

const MoneyInput = ({ 
  label, 
  name, 
  value, 
  onChange, 
  currency = 'Currency', 
  placeholder = '0.00', 
  required = false,
  step = "any"
}) => {
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-white mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <div className="absolute left-3 top-3.5 flex items-center pointer-events-none">
          <span className="text-primary-500 font-bold text-xs tracking-tight">
            {currency}
          </span>
        </div>
        <input
          type="number"
          name={name}
          value={value}
          onChange={onChange}
          step={step}
          required={required}
          className="w-full px-4 py-3 pl-14 border border-secondary-700 bg-secondary-800 rounded-lg text-white focus:ring-2 focus:ring-primary-500 outline-none transition-all placeholder-secondary-500"
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default MoneyInput;